import { Label } from "@/components/ui/label";

interface SeasonalBreakdownProps {
  breakdown: Array<{
    month: string;
    label: string;
    weight: number;
    occFactor: number;
    status: string;
    tagColor: string;
    monthOccupancy: number;
    revenue: number;
    platformFee: number;
    mgmtFee: number;
    payout: number;
    netCashFlow: number;
  }>;
}

const SeasonalBreakdown = ({ breakdown }: SeasonalBreakdownProps) => {
  return (
    <div className="pt-4 border-t space-y-3">
      <div className="flex items-center justify-between">
        <Label className="text-base font-semibold">
          NOVA Month-by-Month Seasonal Pattern
        </Label>
        <span className="text-xs text-muted-foreground italic">
          Jan/Feb slow, May-Jul peak, Fall/Holiday bumps
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2.5 pt-1">
        {breakdown.map((m) => (
          <div
            key={m.month}
            className="p-3 rounded-xl border bg-card flex flex-col justify-between hover:border-primary/50 transition-all shadow-sm"
          >
            <div className="flex items-center justify-between mb-1">
              <span className="font-bold text-sm text-foreground">
                {m.label}
              </span>
              <span
                className={`text-[10px] px-1.5 py-0.5 rounded border ${m.tagColor}`}
              >
                {m.status}
              </span>
            </div>
            <div className="mt-1 space-y-0.5">
              <div className="flex items-baseline justify-between">
                <span className="text-base font-extrabold text-primary">
                  ${m.revenue.toLocaleString()}
                </span>
                <span className="text-xs font-semibold text-muted-foreground">
                  {m.monthOccupancy}% occ
                </span>
              </div>
              <div className="text-[11px] text-muted-foreground flex justify-between">
                <span>Net Payout:</span>
                <span className="font-medium text-emerald-600">
                  ${m.payout.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <p className="text-[10px] text-muted-foreground italic pt-1">
        For display purposes only. These figures are based on projected seasonal
        demand derived from past market trends and are not a guarantee of future
        occupancy, revenue, or results.
      </p>
    </div>
  );
};

export default SeasonalBreakdown;
